import { render, staticRenderFns } from "./Firework.vue?vue&type=template&id=6b5bb324&scoped=true&"
import script from "./Firework.vue?vue&type=script&lang=js&"
export * from "./Firework.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5bb324",
  null
  
)

export default component.exports